import server from "../Server";
import withErrorCheck from "../CheckError";

export interface RemovePlayerFromGroupPayload {
  groupId: number;
  playerId: number;
}

export const RemovePlayerFromGroup = async (payload: RemovePlayerFromGroupPayload): Promise<boolean> => {
  const deleteResponse = await server
    .from("GroupPlayers")
    .delete()
    .eq("group_id", payload.groupId)
    .eq("player_id", payload.playerId);

  withErrorCheck(deleteResponse);
  
  return true;
};
